import React, { useEffect, useState } from 'react';
import FormsList from '../form-creations/FormsList';
import FormCategoriesList from '../form-creations/FormCategoriesList';
import GeneralFormResults from './GeneralFormResults';

const CreateGeneralFormEntries = props => {
  const selectedFormType = 'general';
  const [selectedFormId, setSelectedFormId] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedElementFormId, setSelectedElementFormId] = useState(null);

  useEffect(() => {
    setSelectedCategoryId(null);
    setSelectedElementFormId(null);
  }, [selectedFormId]);

  return (
    <div>
      <div className='grid grid-cols-12 gap-3'>
        <div className='col-span-12 md:col-span-6 xl:col-span-3'>
          <FormsList setSelectedFormId={setSelectedFormId} selectedFormType={selectedFormType} isAllowActions={false} />
        </div>
        {selectedFormId && (
          <div className='col-span-12 md:col-span-6 xl:col-span-3'>
            <FormCategoriesList
              selectedFormType={selectedFormType}
              setSelectedCategoryId={setSelectedCategoryId}
              selectedFormId={selectedFormId}
              setSelectedElementFormId={setSelectedElementFormId}
              isAllowActions={false}
            />
          </div>
        )}
        {selectedCategoryId && (
          <div className='col-span-12 xl:col-span-6'>
            <GeneralFormResults
              selectedCategoryId={selectedCategoryId}
              selectedFormType={selectedFormType}
              patientId={props?.patient_id}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateGeneralFormEntries;
